import { render } from "./card-flight-detail.vue?vue&type=template&id=64d617ee&scoped=true&ts=true"
import script from "./card-flight-detail.vue?vue&type=script&lang=ts"
export * from "./card-flight-detail.vue?vue&type=script&lang=ts"

import "./card-flight-detail.vue?vue&type=style&index=0&id=64d617ee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d617ee"]])

export default __exports__